/*
 * @Autor: Nehc
 * @Date: 2020-11-27 11:16:47
 * @LastEditors: Nehc
 * @LastEditTime: 2020-11-27 11:18:18
 */
import DimensionAndAvail from './table_form.vue';

export default DimensionAndAvail;
